const VueDicts = {};
VueDicts.install = function (Vue, options) {

    // if there is need for another dict,
    // create specialized filter, i.e. 'translate-dict'
    // however the main usecase will be to use prj
    Vue.filter('translate', translatePrj);
}
function translatePrj(dictKey, ...args) {
    let translation = null;

    const dict = window.dict_prj
    if (!dict) {
        return translation;
    }

    if (dict) {
        if (dictKey) {
            translation = dict.get(dictKey, args);
        } else {
            console.error("Dictkey not provided.");
        }
    } else {
        console.error("Global dict_prj not found. Make sure it is loaded before mounting vue or implement an async service.")
    }

    return translation;
}
function translatePrjNonNull(dictKey, ...args) {
    return translatePrj(dictKey, args) || "";
}

export {VueDicts, translatePrj }
